
import { Check, X, UserMinus, UserPlus } from 'lucide-react'
import { Button, ButtonVariant } from '@meiuca/ui-components'
import { ParticipationStatus, type Game } from '@/types/game'
import { useAuthRedirect } from '@/hooks/useAuthRedirect'
import { isGameFull, canParticipate } from '@/utils/gameUtils'

interface GameActionsProps {
  game: Game
  isActionLoading?: string | null
  onJoinGame?: (gameId: string) => void
  onConfirmParticipation?: (gameId: string) => void
  onDeclineInvitation?: (gameId: string) => void
  onCancelParticipation?: (gameId: string) => void
}

export function GameActions({ 
  game, 
  isActionLoading,
  onJoinGame,
  onConfirmParticipation,
  onDeclineInvitation,
  onCancelParticipation 
}: GameActionsProps) {
  const { userStatus } = game
  const { handleAuthAction } = useAuthRedirect()
  
  // Usa helpers centralizados para lógica de jogo
  const gameIsFull = isGameFull(game)
  const userCanParticipate = canParticipate(game, userStatus)

  return (
    <div className="flex items-center space-x-2">
      {userStatus === ParticipationStatus.NOT_PARTICIPANT && (
        <Button
          variant={ButtonVariant.POSITIVE}
          size="sm"
          onClick={() => handleAuthAction(() => onJoinGame?.(game.id))}
          title={gameIsFull ? "Jogo lotado" : "Participar do jogo"}
          loading={isActionLoading === 'join'}
          disabled={!userCanParticipate}
        >
          <UserPlus className="w-4 h-4 mr-1" />
          <span>{gameIsFull ? "Lotado" : "Participar"}</span>
        </Button>
      )}

      {userStatus === ParticipationStatus.INVITED && (
        <>
          {/* Confirmar Participação */}
          <Button
            variant={ButtonVariant.POSITIVE}
            size="sm"
            onClick={() => handleAuthAction(() => onConfirmParticipation?.(game.id))}
            title={gameIsFull ? "Jogo lotado" : "Confirmar participação"}
            loading={isActionLoading === 'confirm'}
            disabled={!userCanParticipate}
          >
            <Check className="w-4 h-4 mr-1" />
            <span>{gameIsFull ? "Lotado" : "Confirmar"}</span>
          </Button>

          {/* Recusar Convite */}
          <Button
            variant={ButtonVariant.NEGATIVE}
            size="sm"
            onClick={() => handleAuthAction(() => onDeclineInvitation?.(game.id))}
            title="Recusar convite"
            loading={isActionLoading === 'decline'}
          >
            <X className="w-4 h-4 mr-1" />
            <span>Recusar</span>
          </Button>
        </>
      )}

      {userStatus === ParticipationStatus.CONFIRMED && (
        <>
          {/* Cancelar Participação */}
          <Button
            variant={ButtonVariant.NEGATIVE}
            size="sm"
            onClick={() => handleAuthAction(() => onCancelParticipation?.(game.id))}
            title="Cancelar participação"
            loading={isActionLoading === 'cancel'}
          >
            <UserMinus className="w-4 h-4 mr-1" />
            <span>Cancelar</span>
          </Button>
        </>
      )}

      {(userStatus === ParticipationStatus.CANCELED || 
        userStatus === ParticipationStatus.DECLINED) && (
        <>
          {/* Confirmar Participação */}
          <Button
            variant={ButtonVariant.POSITIVE}
            size="sm"
            onClick={() => handleAuthAction(() => onConfirmParticipation?.(game.id))}
            title={gameIsFull ? "Jogo lotado" : "Confirmar participação"}
            disabled={!userCanParticipate}
          >
            <Check className="w-4 h-4 mr-1" />
            <span>{gameIsFull ? "Lotado" : "Confirmar"}</span>
          </Button>
        </>
      )}
    </div>
  )
}